import { Home } from './pages/Home';
import { Analytics } from './components/Analytics';

function App() {
  return (
    <>
      <Analytics />
      <Home />
    </>
  );
}

export default App;
